// <Feed> — the compact always-visible recent-activity feed (#feed). 方案 C chat: COLLAPSED = a
// single transparent ticker line (tap to expand, data-action="toggle-chat"); EXPANDED = a
// scrollable .chat-panel of recent lines, each a class="note" card. PURE function of `app`,
// mirroring the classic renderFeed() string. Emits the SAME .ticker / .chat-panel / class="note"
// markup so document-level click delegation (ticker tap → toggle-chat) + the outside-tap collapse
// handler + the smoke grep contract stay green. paintFeed() preserves scroll position around the
// re-mount (reading history shouldn't get yanked to the bottom). See PREACT-MIGRATION.md.
import { html, t } from '../shared.js';
import type { VNode } from 'preact';

export function Feed({ app }: { app: AppState }): VNode | VNode[] | string {
  const blocked: string[] = (app.room && (app.room as any).me && (app.room as any).me.blocked) || [];
  const logs: LogLine[] = ((app.room && app.room.logs) || []).filter((m: LogLine) => !(m.pid && blocked.includes(m.pid))); // chat of someone you blocked
  if (!logs.length || (app.room && app.room.phase === 'lobby')) return '';
  if (app.chatOpen) {
    // Expanded thread: just the scrollable lines. Tapping outside collapses it (capture-phase
    // handler); the full log lives behind the 📜 drawer chip.
    return html`<div class="chat-panel">${logs.slice(-80).map((m: LogLine, i: number) => html`<div class="note" key=${i}><b>${m.who}${t('feed.chatSep')}</b>${m.text}</div>`)}</div>`;
  }
  const last: LogLine = logs[logs.length - 1];
  return html`<div class="ticker" data-action="toggle-chat">💬 <b>${last.who}${t('feed.chatSep')}</b>${last.text} <span class="more">▾</span></div>`;
}
